import React, { useState } from "react";
import Select from "../common/Select";
import SearchDropdown from "../SearchDropdown/SearchDropdown";
import { removeOthers, getUnique } from "../../utils";
import { getSubjectSpecialization } from "../../store/apiCalls/profileDetails";

const SubjectOfIntrestSection = ({
  subjectOfIntrestSection,
  masterData,
  handleSubjectOfIntrestChange,
  handleSelectChange = () => {},
  activeTab,
  handleOthers = () => {},
  renderLinks,
}) => {
  const handleSubjectSelectChange = (value, sectionId, type) => {
    handleSelectChange(value, type, sectionId);
  };

  const [subjectOptions, setSubjectOptions] = useState({});

  const getClasses = () => {
    return "form-group mb-4";
  };

  const getSpecOptions = async (val) => {
    const optionData = removeOthers(
      masterData?.MasterData?.subjectdata,
      val?.subject
    );
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      subjectId: optionData,
    };
    const response = await getSubjectSpecialization(headers, params);
    if (response?.status === 200) {
      let newRecord = response?.data?.data?.data;
      let specOpt = newRecord
        ?.filter(
          (spec) =>
            spec?.specialization !==
            "Other Subject (choose this option to register your subject)"
        )
        .map((spec) => spec?.specialization);
      setSubjectOptions((soi) => ({ ...soi, [val?.subject]: specOpt }));
    } else return;
  };

  return (
    <div className="soi-card mb-4 position-relative">
      <span className="soi-card-label">Subject of Interest</span>
      
      <div className="form-fields-grid row">
        {subjectOfIntrestSection.map((val, ind) => {
          return (
            <div key={ind} className="row m-0 p-0 col-12">
              <div className="col-lg-12 mb-4">
                <div className="position-relative py-2">
                  <Select
                    options={getUnique(
                      masterData?.MasterData?.subjectdata?.map(
                        (val) => val.subjectName
                      ) || []
                    )}
                    name="interestedsubject"
                    placeholder="Select Discipline *"
                    handleChange={(value) =>
                      handleSubjectSelectChange(value, ind, "interestedsubject")
                    }
                    selectedValue={
                      val?.subject && val?.subject !== "" ? val?.subject : null
                    }
                    labelClass=""
                    label="Select Discipline *"
                    required={activeTab === "professional" ? true : false}
                  />
                </div>
              </div>
              <div className="col-lg-12 mb-4">
                <div className="position-relative py-2">
                  <SearchDropdown
                    options={
                      subjectOptions[val?.subject] ??
                      (getSpecOptions(val), [])
                    }
                    disabled={!val?.subject}
                    index={ind}
                    keyName="subject"
                    onChange={(e) => handleSubjectOfIntrestChange(e, ind)}
                    selectedValue={val?.specialization}
                    labelClass=""
                    handleOtherOption={(data) => handleOthers(data, ind)}
                    name="Interested Specialization"
                    selected="Subject"
                    placeholder={
                      val?.specialization?.length === 0
                        ? "Select Subject *"
                        : val?.specialization.length > 1
                        ? val?.specialization[0] +
                          " +" +
                          String(val?.specialization.length - 1)
                        : val?.specialization[0]
                    }
                    label="Select Subject *"
                  />
                </div>
              </div>
            </div>
          );
        })}
        {renderLinks && (
          <div className="col-12 mt-2 text-start link-container d-flex align-items-center justify-content-between flex-wrap gap-3">
            {renderLinks()}
            <span className="soi-limit-note">*You can add up to 3 subject of interest</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubjectOfIntrestSection;
